import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AlertInfo } from '../../../../models/alert-info';
import { SavedDataInfo } from '../../../../models/form/saved-data-info';
import { FormService } from '../../../../services/form.service';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { TextAreaFieldComponent } from '../../../../components/form/textarea-field/textarea-field.component';

@Component({
  selector: 'proposals-reason-change-of-scope',
  imports: [NgbAlert, TextAreaFieldComponent, ReactiveFormsModule],
  templateUrl: './proposals-reason-change-of-scope.component.html',
  styleUrl: './proposals-reason-change-of-scope.component.scss'
})
export class ProposalsReasonChangeOfScopeComponent {

  @Input() proposal?: any;
  @Input() readonlyReasonChangeOfScope: boolean = false;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();

  form: FormGroup = new FormGroup({
    changeOfScopeReason: new FormControl('', Validators.required),
  });

  alertInfo: AlertInfo = { show: false, type: '', message: '' };

  constructor(
    private formService: FormService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['proposal'] && changes['proposal'].currentValue) {
      this.form.patchValue({
        changeOfScopeReason: this.proposal.changeOfScopeReason,
      });
    }
  }

  /**
   * *******************
   * Submit form methods
   * *******************
   */
  showAlertInfo(type: string, message: string) {
    this.alertInfo = {
      show: true,
      type,
      message
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }
  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.form);
    this.formService.setValidationErrors(this.form, validationErrors);
  }
  submitFormSuccess(response: any) {
    this.onSavedData.emit({
      success: true,
      response
    });
  }
  submitFormError(error: any) {

    if (error.error.error.description == 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
    }
    else {
      this.showAlertInfo('danger', error.error.error.message);
    }

    this.onSavedData.emit({
      success: false,
      error
    });

  }
  submitForm(): void {

    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.markAsTouched();
      control?.updateValueAndValidity();
    });

    if (this.form.valid) {
      this.alertInfo.show = false;
      this.formService.resetErrors(this.form);

      this.submitFormSuccess(this.form.value);
    } else {
      this.showAlertInfo('danger', 'Please provide the reason of change of scope');
      this.onSavedData.emit({ success: false, error: null });
    }
  }
  /**
   * *******************
   * Submit form methods
   * *******************
   */

  getChangeOfScopeReasonInput(): FormControl { return this.getFormControl('changeOfScopeReason'); }

  getFormControl(name: string): FormControl { return this.form.get(name) as FormControl; }
}
